import { Nav, Navbar, Container, Dropdown } from 'react-bootstrap';
import CRC from 'style/CRC.png'

function Footer() {
    if (window.location.pathname.includes("/mbko")) return (<></>)
    return (
        <div className="mt-auto">
            <Dropdown.Divider style={{ margin: 0 }} />
            <Navbar key="md" expand="lg" className="d-none d-xl-flex">
                <Container>
                    <Nav className="containerflex-grow-1 pe-3">
                        <Nav.Link className="md-6" href="https://www.acrc.go.kr/"> <img src={CRC} alt="CRC" /> </Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            <Dropdown.Divider style={{ margin: 0 }} />
            <Navbar key="md" style={{ background: "rgb(82, 82, 82)", color: "rgb(255,255,255)" }} >
                <Container>
                    <Nav className="container flex-grow-1 pe-3 align-items-center" >
                        <Nav.Link className="md-6 pe-3" style={{ color: "rgb(255,255,255)" }} href="/personal">개인정보처리방침</Nav.Link>
                        |
                        <Nav.Link className="md-6 px-3" style={{ color: "rgb(255,255,255)" }} href="/using">이용약관 </Nav.Link>
                        |
                        <Nav.Link className="md-6 px-3" style={{ color: "rgb(255,255,255)" }} href="/email">이메일주소무단수집거부 </Nav.Link>
                        {/* |
                        <span className="d-none d-md-flex align-items-center">
                            <Link to="/empty" style={{ textDecoration: 'none' }}>
                                <Nav.Link className="md-6 px-3" style={{ color: "rgb(255,255,255)" }} href="#action3">사이트맵 </Nav.Link>
                            </Link>
                                |
                            <Link to="/empty" style={{ textDecoration: 'none' }}>
                                <Nav.Link className="md-6 px-3" style={{ color: "rgb(255,255,255)" }} href="#action3">찾아오시는길 </Nav.Link>
                            </Link>
                        </span> */}
                    </Nav>
                </Container>
            </Navbar>
            <Dropdown.Divider style={{ margin: 0 }} />
            <div className="p-3" style={{ background: "rgb(82, 82, 82)", textAlign: 'left', color: "rgb(255,255,255)" }}>
                <Container >
                    <div className="mx-2" style={{ fontSize: "10px" }}>
                        서울특별시 광진구 용마산로 1길 54, 101호(중곡동)<br></br>
                        고유번호 : 255-82-00417 Tel:070-4196-3411 Mail:kbsf2019@naver.com<br></br>
                        Copyright(c) 2022 (사)한국브레인스포츠연맹. All Right Reserved
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Footer;
